import { render, staticRenderFns } from "./TrocarMedicoComp.vue?vue&type=template&id=ba25c70e&"
import script from "./TrocarMedicoComp.vue?vue&type=script&lang=js&"
export * from "./TrocarMedicoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports